(function() {
    "use strict";

    var $ = jQuery;
    var msg = jimdoData.messages.callback;
    var alreadyOpened = false;
    var callbackForm = $();

    var openDialog = function() {
        if (alreadyOpened) {
            return;
        }
        alreadyOpened = true;
        callbackForm = $('<div class="callback-form-wrapper"></div>');

        callbackForm.diy_dialog({
            title: msg.dialogTitle,
            dialogClass: 'callback-dialog',
            modal: false,
            resizable: false,
            closeButton: true,
            width: 404,
            zIndex: 100100,
            close: function() {
                formXHR.abort();
                $(this).diy_dialog('destroy').remove();
                alreadyOpened = false;
            }
        });
        callbackForm.loadingBox({useOverlay: true}).show();

        var formXHR = $.ajax({
            url: '/app/help/callback/form',
            success: function (response) {
                require(['3rd-party/libphonenumber/libphonenumber'], function(i18n){
                    var libphonenumber = i18n.phonenumbers;

                    callbackForm.html(response);
                    var callNowBtn = callbackForm.find('.callback-call-now');
                    callNowBtn.button({
                        icons: {primary : "callback-call-now-icon"}
                    });

                    var phoneInput = $('#callback_phone', callbackForm);
                    var contactNameInput = $('#callback_name', callbackForm);
                    var countryCombo = $('#callback_country_placeholder');

                    var deleteCusomerData = $('#deletePersonalData', callbackForm);
                    if (deleteCusomerData) {
                        var oldValuesPhone = phoneInput.val(),
                            oldValuesCustomerName = contactNameInput.val();
                        deleteCusomerData
                            .addClass(' ui-button-borderless')
                            .button({
                                text: false,
                                icons: {
                                    primary: 'ui-icon-trash'
                                }
                            })
                            .diy_simpleCallout({
                                content: msg.deletePersonalData,
                                cls: 'callback-delete-tooltip',
                                closable: false,
                                autoHide: true,
                                triggerMode: 'hover',
                                footer: false
                            })
                            .click(function(){
                                callbackForm.loadingBox({useOverlay: true}).show();
                                jQuery.ajax({
                                    type: 'post',
                                    url: '/app/help/callback/save-callback-details',
                                    data: {
                                        callbackName: '',
                                        callbackUnparsedNumber: '',
                                        callbackUnparsedCountry: ''
                                    },
                                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                                    success : function(response) {
//                                        deleteCusomerData.parent().remove();
                                        $('div.callback-details-delete', callbackForm).remove();
                                        phoneInput.val('');
                                        contactNameInput.val('');
                                        jQuery.cookie('contactPhoneInput', '', {path:'/'});
                                        jQuery.cookie('contactNameInput', '', {path:'/'});
                                        jQuery.cookie('contactCountryInput', 'other', {path:'/'});
                                        countryCombo.diy_combobox('rawValue', 'OTHER');
                                        callbackForm.loadingBox().hide();
                                    }
                                });
                            });
                    }

                    phoneInput.diy_textField({
                        tooltipOptions: {
                            anchor: 'right'
                        }
                    });
                    phoneInput.bind('keydown', function(key){
                        phoneInput.diy_textField('clearInvalid');
                    });
                    phoneInput.bind('keyup', function(key){
                        jQuery.cookie('contactPhoneInput', phoneInput.val(), {path:'/'});
                        if (deleteCusomerData && oldValuesPhone && oldValuesPhone != phoneInput.val()) {
//                            deleteCusomerData.parent().remove();
                            $('div.callback-details-delete', callbackForm).remove();
                        }
                    });

                    contactNameInput.bind('keyup', function(key){
                        jQuery.cookie('contactNameInput', contactNameInput.val(), {path:'/'});
                        if (deleteCusomerData && oldValuesCustomerName && oldValuesCustomerName != contactNameInput.val()) {
//                            deleteCusomerData.parent().remove();
                            $('div.callback-details-delete', callbackForm).remove();
                        }
                    });



                    countryCombo.diy_combobox({
                        forceSelection:true,
                        menuCssClass: 'callback-country',
                        renderPreview: function(elem, item){
                            elem.empty();
                            var imgEl = jQuery("<span></span>");
                            imgEl.attr('style', 'display: inline-block');
                            imgEl.addClass(item.iconcssclass);
                            imgEl.appendTo(elem);
                        },
                        renderItem: function(elem, item){
                            var imgEl = jQuery("<span></span>");
                            imgEl.addClass("previewImage " + item.iconcssclass);
                            elem.text(item.label);
                            imgEl.appendTo(elem);
                        },
                        select: function ( event, item ) {
                            jQuery.cookie('contactCountryInput', item.rawValue, {path:'/'});
                        },
                        showInput: false
                    });

                    $('.callback-call-now', callbackForm).click(function(){
                        var res = validatePhoneInput(libphonenumber, phoneInput, countryCombo, false);
                        if (res) {
                            callbackForm.loadingBox({useOverlay: true}).show();
                            registerCallback(
                                $('#callback_name', callbackForm).val(),
                                res.e164Format,
                                res.internationalFormat,
                                $('#callback_phone', callbackForm).val(),
                                $('#callback_country', callbackForm).val()
                            );
                        }
                    });
                    callbackForm.loadingBox().remove();
                });
            }
        });
    };

    var validatePhoneInput = function(libphonenumber, phoneInput, countryCombo, forceCountry) {
        var phoneNumber = phoneInput.val();
        var regionCode = countryCombo.diy_combobox('rawValue');
        if (regionCode == 'OTHER') {
            regionCode = null;
        }
        try {
            phoneInput.diy_textField('clearInvalid');
            phoneInput.diy_textField('clearErrors');
            var validationRes = validatePhoneNumber(libphonenumber, phoneNumber, regionCode, forceCountry);
            if (!forceCountry && validationRes.regionCode != regionCode) {
                countryCombo.diy_combobox('rawValue', validationRes.regionCode);
                if (validationRes.regionCode != countryCombo.diy_combobox('rawValue')) {
                    // then it's a region not present in the combobox value
                    // let's set it to OTHER COUNTRY
                    countryCombo.diy_combobox('rawValue', 'OTHER');
                }
                jQuery.cookie('contactCountryInput', countryCombo.diy_combobox('rawValue'), {path:'/'});
            }
            return validationRes;
        } catch (e) {
            phoneInput.diy_textField('addError', e);
            phoneInput.diy_textField('showError');
        }
    };

    var validatePhoneNumber = function(libphonenumber, phoneNumber, regionCode, forceCountry) {
        var phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        var errorMsg = null;
        try {
            var number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode);

            var isPossible = phoneUtil.isPossibleNumber(number);

            if (!isPossible) {
                errorMsg = msg.error.invalidPhone;
                /*
                var PNV = libphonenumber.PhoneNumberUtil.ValidationResult;
                switch (phoneUtil.isPossibleNumberWithReason(number)) {
                  case PNV.INVALID_COUNTRY_CODE:
                    errorMsg = 'INVALID_COUNTRY_CODE';
                    break;
                  case PNV.TOO_SHORT:
                    errorMsg = 'TOO_SHORT';
                    break;
                  case PNV.TOO_LONG:
                    errorMsg = 'TOO_LONG';
                    break;
                  default:
                    errorMsg = 'GENERAL_IMPOSSIBLE_ERROR';
                }
                */
              } else {
                  if (forceCountry && regionCode) {
                      if (!phoneUtil.isValidNumberForRegion(number, regionCode)) {
                          //errorMsg = 'NUMBER_INVALID_FOR_COUNTRY';
                          errorMsg = msg.error.invalidPhoneForCountry;
                      }
                  } else {
                      if (!phoneUtil.isValidNumber(number)) {
                          //errorMsg = 'NUMBER_INVALID';
                          errorMsg = msg.error.invalidPhone;
                      }
                  }
                  if (!errorMsg) {
                      return {
                          e164Format: phoneUtil.format(number, libphonenumber.PhoneNumberFormat.E164),
                          internationalFormat: phoneUtil.format(number, libphonenumber.PhoneNumberFormat.INTERNATIONAL),
                          regionCode: phoneUtil.getRegionCodeForNumber(number)
                      };
                  }
              }
        } catch (e) {
            //errorMsg = 'GENERAL_EXCEPTION_ERROR';
            if (regionCode) {
                errorMsg = msg.error.invalidPhone;
            } else {
                errorMsg = msg.error.invalidPhoneForOtherCountry;
            }
        }
        if (errorMsg) {
            throw errorMsg;
        }
    };

    var showInputErrror = function (element, errorMsg) {
        element.diy_textField({
            tooltipOptions: {
                anchor: 'right'
            }
        });
        element.diy_textField('addError', errorMsg);
        element.diy_textField('showError');
        element.bind('keydown', function(key){
            element.diy_textField('clearInvalid');
            element.diy_textField('clearErrors');
        });
    };

    var registerCallback = function (name, phone, phoneText, originalNumber, originalCountry) {
        $.ajax({
            url: '/app/help/callback/register-callback',
            type: 'POST',
            data: {
                callbackName: name,
                callbackPhone: phone,
                callbackPhoneText: phoneText,
                callbackUnparsedNumber: originalNumber,
                callbackUnparsedCountry: originalCountry
            },
            success: function(response) {
                callbackForm.loadingBox().hide();
                if (response.status === 'success') {
                    callbackForm.diy_dialog('close');
                    var callingDialog = $(response.html);
                    callingDialog.diy_dialog({
                        title: msg.dialogTitle,
                        dialogClass: 'callback-dialog',
                        modal: false,
                        resizable: false,
                        closeButton: true,
                        width: 404,
                        close: function() {
                            $(this).dialog('destroy').remove();
                            alreadyOpened = false;
                        }
                    });
                    alreadyOpened = true;

                    var resetLink = jQuery('#callback_reset_link', callingDialog);
                    resetLink
                        .blur()
                        .click(function(e){
                            e.preventDefault();
                            callingDialog.diy_dialog('close');
                            openDialog();
                        });

                    var dataChangedCheckbox = jQuery('#save_personal_data', callingDialog);
                    dataChangedCheckbox.diy_checkbox({
                        change: function ()
                        {
                            if (this.checked == true) {
                                var callbackContainer = jQuery('.callback-data-changed', callingDialog);
                                callbackContainer.loadingBox({useOverlay: true}).show();
                                jQuery.ajax({
                                    type: 'post',
                                    url: '/app/help/callback/save-callback-details',
                                    data: {
                                        callbackName: name,
                                        callbackUnparsedNumber: originalNumber,
                                        callbackUnparsedCountry: originalCountry
                                    },
                                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                                    success : function(response) {
                                        jQuery('.callback-save-personal-data', callingDialog).hide();
                                        jQuery('.callback-legal', callingDialog).show();
                                        callbackContainer.loadingBox().remove();
                                    }
                                });
                            }
                        }
                    });
                } else {
                    switch (response.status) {
                        case 'invalid_customer_name':
                            showInputErrror($('#callback_name', callbackForm), response.message);
                            break;
                        case 'invalid_customer_phone':
                            showInputErrror($('#callback_phone', callbackForm), response.message);
                            break;
                        case 'error':
                        default:
                            callbackForm.diy_form({
                                messageTarget: '.callbak-form-error'
                            });
                            callbackForm.diy_form('showErrorMessage', response.message);
                            break;

                    }
                }
            }
        });
    };

    var insertWorkingHours = function (element, workingHours) {
        var timeline = [];
        // we will normalize intervals in case of possible overlaps
        // and then will split up by days
        for (var i = 0; i < workingHours.length; i++) {
            timeline.push({
                type: 'start',
                datetime: new Date(workingHours[i][0])
            });
            timeline.push({
                type: 'end',
                datetime: new Date(workingHours[i][1])
            });
        }
        timeline.sort(function(a, b) {
            var diff = a.datetime.getTime() - b.datetime.getTime();
            // put "start" first then "end", to easyly concatenate
            // adiacent intervals
            if (diff === 0 && a.type !== b.type) {
                return a.type === 'start' ? -1 : 1;
            }
            return diff;
        });

        var dateIntervals = [], dates = [], currentDate, stackLevel = 0, ct;
        for (var i = 0; i < timeline.length; i++) {
            ct = timeline[i].datetime;
            currentDate = new Date(ct.getFullYear(), ct.getMonth(), ct.getDate());
            if (timeline[i].type === 'start') {
                if (stackLevel === 0) {
                    // we start a new working interval
                    if (dates.length > 0
                        && dates[dates.length - 1].getTime() === currentDate.getTime()
                    ) {
                        // in the current day
                        dateIntervals[dateIntervals.length - 1].push([ct]);
                    } else {
                        // in the next day
                        dates.push(currentDate);
                        dateIntervals.push([[ct]]);
                    }
                }
                stackLevel++;
            } else if (timeline[i].type === 'end') {
                stackLevel--;
                if (stackLevel === 0) {
                    // we end last working interval, but split up by days
                    while (dates[dates.length - 1].getTime() < currentDate.getTime()) {
                        var lD = dates[dates.length - 1];
                        dates.push(new Date(lD.getFullYear(), lD.getMonth(), lD.getDate() + 1));
                        var lDI = dateIntervals[dateIntervals.length - 1];
                        lDI[lDI.length - 1].push(new Date(lD.getFullYear(), lD.getMonth(), lD.getDate(), 23, 59));
                        dateIntervals.push([[new Date(lD.getFullYear(), lD.getMonth(), lD.getDate() + 1, 0, 0)]]);
                    }
                    var lDI = dateIntervals[dateIntervals.length - 1];
                    lDI[lDI.length - 1].push(ct);
                }
            }
        }
        var msg = jimdoData.messages;
        var today = new Date(), dayName;
        var tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        for (var i = 0; i < dates.length; i++) {
            var dateEl = $('<div class="wh-date"></div>');
            if (dates[i].getFullYear() === today.getFullYear()
                && dates[i].getMonth() === today.getMonth()
            ) {
                if (dates[i].getDate() === today.getDate()) {
                    dayName = msg.today;
                } else if (dates[i].getDate() === tomorrow.getDate()) {
                    dayName = msg.tomorrow;
                } else {
                    dayName = msg.weekdays[dates[i].getDay()];
                }
            } else {
                dayName = msg.weekdays[dates[i].getDay()];
            }

            dateEl.append('<span class="wh-day">' + dayName + '</span>');
            dateEl.appendTo(element);
            var timeFormat = function(a) {
                // strip seconds letting possible AM/PM marker
                return a.toLocaleTimeString().replace(/^(.*):(.*):([^\s]*)(\s(.*))?$/, '$1:$2$4');
            };
            var hoursHtml = [];
            for (var j = 0; j < dateIntervals[i].length; j++) {
                var start = dateIntervals[i][j][0];
                var end = dateIntervals[i][j][1];
                hoursHtml.push('<span class="wh-hour">'
                        + timeFormat(start)
                        + ' - '
                        + timeFormat(end)
                        + '</span>');
            }
            dateEl.append(hoursHtml.join(','));
        }
    };

    module.exports = {
        openDialog : openDialog,
        insertWorkingHours: insertWorkingHours
    };

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/help/callback/callback.js
 ** module id = 728
 ** module chunks = 0
 **/